import { render, staticRenderFns } from "./toRelease.vue?vue&type=template&id=086433e1&"
import script from "./toRelease.vue?vue&type=script&lang=js&"
export * from "./toRelease.vue?vue&type=script&lang=js&"
import style0 from "./toRelease.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports